const APKData = {
  YGBmlVNh1Joq3KYjUR4b: "https://i.diawi.com/HpEbBw",
}

export default APKData
